export default {
  className: 'identity',
  render: (residentialQuarters) => {
    return `${residentialQuarters.name}`
  },
  fields: [
    {
      name: 'name',
      validators: [
        // (val) => val ? null : '楼号不可为空'
      ]
    }
  ]
}
